
import type { PropType, SetupContext } from 'vue'
import type { EpbSelectDropdownOptionType, EpbSelectOption } from './epb-select.types'
import { computed, defineComponent, ref } from 'vue'
import { ColorEnum } from '../../../enums'
import { UiCheckbox, UiRadio } from '../../keen-ui'
import { EpbText } from '../epb-text'

export default defineComponent({
  name: 'EpbSelectDropdownOption',
  components: {
    EpbText,
    UiCheckbox,
    UiRadio,
  },
  props: {
    option: {
      type: Object as PropType<EpbSelectOption>,
      required: true,
    },
    type: {
      type: String as PropType<EpbSelectDropdownOptionType>,
      default: 'default',
    },
    selected: {
      type: Boolean,
    },
    showCheckbox: Boolean,
  },
  emits: {
    input: (value: string | Array<string>) => {},
    change: (value: string | Array<string>) => {},
    click: () => {},
  },

  setup(props, ctx: SetupContext) {
    const baseClass = 'epb-select-dropdown-option'
    const optionRef = ref<HTMLElement>(null)
    const label = ref()

    const showRadio = computed(() => props.type === 'radio')

    function transformLabel(hover: boolean): void {
      const labelEl = label.value.$el as HTMLElement
      const labelChildEl = labelEl.firstChild as HTMLElement
      let transform: string, transitionDuration: string
      if (hover) {
        const offset = Math.min(labelEl.clientWidth - labelChildEl.clientWidth, 0)
        transform = `translate3d(${offset}px, 0, 0)`
        transitionDuration = `${Math.abs(offset) * 10}ms`
      } else {
        transform = ''
        transitionDuration = ''
      }
      labelChildEl.style.transform = transform
      labelChildEl.style.transitionDuration = transitionDuration
    }

    function onSelect(option: EpbSelectOption): void {
      ctx.emit('select', option)
      ctx.emit('click')
    }

    const buttonStyle = computed<Partial<CSSStyleDeclaration>>(() => {
      if (props.option.level > 0) {
        return {
          paddingLeft: `${props.option.level * 20}px`,
          fontSize: `${15 - props.option.level}px`,
        }
      }
      return {}
    })

    return {
      baseClass,
      buttonStyle,
      optionRef,
      label,
      transformLabel,
      showRadio,
      onSelect,
      ColorEnum,
    }
  },
})
